const OnboardingTitle = ({ title }: { title: string }) => {
  return (
    <div className={'font-extrabold text-base text-center text-balance'}>
      {title}
    </div>
  );
};

export default OnboardingTitle;
